import * as Yup from 'yup';

export const createAnnouncement = Yup.object().shape({
  ansMessage: Yup.string().required('El anuncio no debe estar vacio'),
});
